// Use this to initialise on document ready

$(document).ready(function() {
	'use strict';

    $('body').addClass('js-enabled');

    // Init external libraries
    $('.js-accordion').accordion();

});